<template lang="html">
    <!-- Facets body -->
    <div class="facets">
        <div class="facets__tags-header">
            <span>Filtrér efter</span>
            <a href="#" @click="closeAndScroll(false)">
                <svg class="bi" width="21" height="21" fill="currentColor">
                    <use href="../../static/bi-sprite.svg#x-light" />
                </svg>
            </a>
        </div>
        <div class="facets__tags" v-if="selected.length">
            <a class="facets__tag facets__tag--all" @click="() => reset(false)">
                Fjern alle
            </a>
            <div v-for="tag in selected">
                <a
                    class="facets__tag"
                    v-for="(value, key) in tag"
                    @click="() => removeTag(key, value)"
                >
                    {{ key.replace("FACET_", "") }}:
                    <strong>{{ value }}</strong>
                    <svg class="bi" width="16" height="16" fill="currentColor">
                        <use href="../../static/bi-sprite.svg#x" />
                    </svg>
                </a>
            </div>
        </div>
        <div class="col-12 facets__footer">
            <a class="btn btn-outline-primary" @click="() => reset(true)"
                >Luk</a
            >
            <a class="btn btn-primary" @click="closeAndScroll(false)"
                >Vis produkter ({{ settings.productsCount }})</a
            >
        </div>
        <div
            v-for="(facet, i) in facets"
            :key="facet.id"
            class="facets__group"
            :class="{ 'facets__group--closed': !openFacets.includes(facet.id) }"
        >
            <button class="facets__header" @click="toggleFacet(facet.id)">
                {{ facet.name }}
            </button>
            <div class="facets__options">
                <div class="facets__option" v-for="option in facet.options">
                    <div class="custom-control custom-checkbox">
                        <input
                            type="checkbox"
                            class="custom-control-input"
                            :id="option.id + '_' + i"
                            @change="update(facet.id, option, $event)"
                            :checked="option.selected"
                        />
                        <label
                            :for="option.id + '_' + i"
                            class="facets__label custom-control-label"
                        >
                            <span>{{ option.name }}</span>
                        </label>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from "vue";
import { mapGetters, mapState } from "vuex";

export default Vue.extend({
    name: "Facets",
    components: {},
    props: ["open"],
    data() {
        return {
            loading: true,
            openFacets: [],
        };
    },
    mounted() {
        const desktop = window.matchMedia("(min-width: 768px)").matches;
        const initialOpenAmount = desktop ? 3 : 1;

        this.facets?.forEach((element, index) => {
            if (index < initialOpenAmount) {
                this.openFacets.push(element.id);
            }
        });
    },
    methods: {
        closeAndScroll() {
            this.$emit("toggle", false);
            let filterY = document.getElementById("filter").offsetTop;
            if (filterY < window.scrollY) {
                window.scrollTo(0, filterY);
            }
        },
        update(facetId, option, e) {
            this.$store.commit("FACETS", {
                single: true,
                facetId: facetId,
                option: option,
                selected: e.target.checked,
            });
            this.$store.dispatch("search", {});
            const plp = document.querySelector(".js-product-list-page");
            plp.scrollIntoView({
                behavior: "instant",
                block: "start",
                inline: "nearest",
            });
        },
        reset(close) {
            this.$store.dispatch("reset");
            this.$store.dispatch("search", {});
            if (close) {
                this.$emit("toggle", false);
            }
        },
        toggleFacet(facetId) {
            let index = this.openFacets.indexOf(facetId);
            if (index > -1) {
                this.openFacets.splice(index, 1);
            } else {
                this.openFacets.push(facetId);
            }
        },
        removeTag(facetId, optionId) {
            const facet = this.facets.find((facet) => facet.id === facetId);
            const option = facet?.options.find(
                (option) => option.id === optionId
            );
            if (facet && option) {
                this.$store.commit("FACETS", {
                    single: true,
                    facetId: facetId,
                    option: option,
                    selected: false,
                });
                this.$store.dispatch("search", {});
            }
        },
    },
    computed: {
        ...mapState(["facets", "settings", "dict", "collectionMode"]),
        ...mapGetters(["selected"]),
    },
});
</script>
